import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-avatar-demo"
export default class extends Controller {
  static targets = ["trigger", "dropdown"]

  connect() {
    this.isOpen = false
    this.closeOnEsc = this.closeOnEsc.bind(this)
    this.closeOnOutside = this.closeOnOutside.bind(this)
  }

  disconnect() {
    this.removeGlobalListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.isOpen ? this.close() : this.open()
  }

  open() {
    if (this.isOpen) return

    this.isOpen = true
    this.dropdownTarget.classList.remove("hidden")
    this.dropdownTarget.classList.add("block")
    this.addGlobalListeners()
  }

  close() {
    if (!this.isOpen) return

    this.isOpen = false
    this.dropdownTarget.classList.add("hidden")
    this.dropdownTarget.classList.remove("block")
    this.removeGlobalListeners()
  }

  closeOnEsc(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  addGlobalListeners() {
    document.addEventListener("keydown", this.closeOnEsc)
    document.addEventListener("click", this.closeOnOutside)
  }

  removeGlobalListeners() {
    document.removeEventListener("keydown", this.closeOnEsc)
    document.removeEventListener("click", this.closeOnOutside)
  }
}
